<template>
  <div id="social-essay-form">
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-6">
        <!-- BEGIN: Form Layout -->
        <div class="intro-y box p-5">

          <div class="mt-3 flex">

            <div class="flex-1">
              <label for="site_id" class="form-label">分站</label>
              <div id="site_id" class="w-full" v-if="site">{{ site.name }}</div>
              <div v-if="'site_id' in errors" class="text-danger mt-2" v-html="errors.site_id"></div>
            </div>

            <div class="flex-1">
              <div class="form-switch flex items-center">
                <label class="pointer flex">
                  <input type="checkbox" class="form-check-input mr-2" v-model="form.is_manager" :value="1">
                  <div>社服隨筆</div>
                </label>
              </div>
            </div>
          </div>

          <div class="mt-3">
            <label for="description" class="form-label"><span class="text-danger">*</span> 標題</label>
            <input v-model="form.title" id="description" type="text" class="form-control w-full" placeholder="請輸入標題">
            <div v-if="'title' in errors" class="text-danger mt-2" v-html="errors.title"></div>
          </div>

          <div class="mt-3">
            <label for="editor" class="form-label"><span class="text-danger">*</span> 內容</label>
            <ckeditor :editor="editor" v-model="form.content" :config="editorConfig" />
            <div v-if="'content' in errors" class="text-danger mt-2" v-html="errors.content"></div>
          </div>

          <div class="mt-3" v-if="false">
            <label for="post_date" class="form-label">新增時間</label>
            <div id="post_date">
              <date-picker v-model="post_date" type="datetime" placeholder="請選擇新增時間" input-class="form-control w-full"></date-picker>
            </div>
            <div v-if="'post_date' in errors" class="text-danger mt-2" v-html="errors.post_date"></div>
          </div>

          <div class="mt-3">
            <label for="display_at" class="form-label">公開時間</label>
            <div id="display_at">
              <date-picker v-model="display_at" type="datetime" placeholder="請選擇公開時間" input-class="form-control w-full" :disabled-date="disabledStartDate" :disabled-time="disabledStartTime"></date-picker>
            </div>
            <div v-if="'display_at' in errors" class="text-danger mt-2" v-html="errors.display_at"></div>
          </div>

          <div class="mt-3">
            <label for="end_at" class="form-label">結束公開時間</label>
            <div id="end_at">
              <date-picker v-model="end_at" type="datetime" placeholder="請選擇結束公開時間" input-class="form-control w-full" :disabled-date="disabledEndDate" :disabled-time="disabledEndTime"></date-picker>
            </div>
            <div v-if="'end_at' in errors" class="text-danger mt-2" v-html="errors.end_at"></div>
          </div>

          <div class="mt-3">
            <label for="is_pinned" class="form-label">置頂</label>
            <div class="form-switch">
              <input id="is_pinned" v-model="form.is_pinned" type="checkbox" class="form-check-input">
            </div>

            <div v-if="'is_pinned' in errors" class="text-danger mt-2" v-html="errors.is_pinned"></div>
          </div>

          <div class="mt-3">
            <label for="status" class="form-label"><span class="text-danger">*</span> 狀態</label>
            <select id="status" v-model="form.status" class="form-select" aria-label="請選擇狀態">
              <option value="">--- 請選擇 ---</option>
              <option v-for="(item, key) in allStatus" :key="key" :value="item.value">{{ item.name }}</option>
            </select>
            <div v-if="'status' in errors" class="text-danger mt-2" v-html="errors.status"></div>
          </div>

          <div class="flex justify-end align-items-center mt-5">
            <router-link v-if="!loading && !finish" :to="`/social-essays?isManager=${form.is_manager ? 1 : 0}`" type="button" class="btn btn-outline-secondary w-24 mr-1">取消</router-link>
            <button v-if="!loading && !finish" type="button" class="btn btn-primary w-24" @click="onSave">儲存</button>
            <span v-show="loading && !finish"><i data-loading-icon="oval" class="w-8 h-8"></i></span>
          </div>
        </div>
        <!-- END: Form Layout -->
      </div>
    </div>

    <file-insertor :auth="auth" :current-site="currentSite" :permissions="permissions" :profile="profile" @on-select="onSelectInsertFile" ref="fileInsertor"></file-insertor>
  </div>
</template>

<script>
/* global CKEDITOR */
import InsertLibraryFile from '../extension/ckeditorInsertLibraryFile'

const {
  ClassicEditor,
  Alignment,
  Autoformat,
  AutoImage,
  AutoLink,
  Autosave,
  Base64UploadAdapter,
  Bold,
  CloudServices,
  Essentials,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  Fullscreen,
  GeneralHtmlSupport,
  Highlight,
  HorizontalLine,
  ImageBlock,
  ImageCaption,
  ImageInline,
  ImageInsert,
  ImageInsertViaUrl,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Indent,
  IndentBlock,
  Italic,
  Link,
  LinkImage,
  List,
  ListProperties,
  MediaEmbed,
  Paragraph,
  PasteFromOffice,
  RemoveFormat,
  SourceEditing,
  Strikethrough,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
  TextTransformation,
  TodoList,
  Underline
} = CKEDITOR

export default {
  props: ['site', 'data', 'auth', 'currentSite', 'permissions', 'profile', 'isManager'],
  data() {
    return {
      mode: 'create',
      form: {
        site_id: null,
        is_manager: false,
        title: null,
        content: '',
        post_date: null,
        display_at: null,
        end_at: null,
        display_order: 0,
        is_pinned: false,
        status: ''
      },
      errors: {},
      loading: false,
      finish: false,

      post_date: null,
      display_at: null,
      end_at: null,

      allStatus: [
        { name: '草稿', value: 'DRAFT' },
        { name: '公開', value: 'PUBLISHED' }
      ],

      editor: ClassicEditor,
      editorConfig: {
        licenseKey: process.env.VUE_APP_CKEDITOR5_LICENSE_KEY, // Or 'GPL'.
        bodyClass: 'html-content',
        toolbar: {
          items: [
            'undo',
            'redo',
            '|',
            'sourceEditing',
            'fullscreen',
            '|',
            'fontSize',
            'fontFamily',
            'fontColor',
            'fontBackgroundColor',
            '|',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'removeFormat',
            '|',
            'horizontalLine',
            'link',
            'insertLibraryFile',
            // 'insertImage',
            'mediaEmbed',
            'insertTable',
            'highlight',
            '|',
            'alignment',
            '|',
            'bulletedList',
            'numberedList',
            'todoList',
            'outdent',
            'indent'
          ],
          shouldNotGroupWhenFull: true
        },
        plugins: [
          InsertLibraryFile,
          Alignment,
          Autoformat,
          AutoImage,
          AutoLink,
          Autosave,
          Base64UploadAdapter,
          Bold,
          CloudServices,
          Essentials,
          FontBackgroundColor,
          FontColor,
          FontFamily,
          FontSize,
          Fullscreen,
          GeneralHtmlSupport,
          Highlight,
          HorizontalLine,
          ImageBlock,
          ImageCaption,
          ImageInline,
          ImageInsert,
          ImageInsertViaUrl,
          ImageResize,
          ImageStyle,
          ImageTextAlternative,
          ImageToolbar,
          ImageUpload,
          Indent,
          IndentBlock,
          Italic,
          Link,
          LinkImage,
          List,
          ListProperties,
          MediaEmbed,
          Paragraph,
          PasteFromOffice,
          RemoveFormat,
          SourceEditing,
          Strikethrough,
          Table,
          TableCaption,
          TableCellProperties,
          TableColumnResize,
          TableProperties,
          TableToolbar,
          TextTransformation,
          TodoList,
          Underline
        ],
        insertLibraryFile: {
          onButtonClickCallback: this.showFileInsertor
        },
        fontFamily: {
          options: ['新細明體', '細明體', '標楷體', '微軟正黑體', '微軟雅黑體', 'serif', 'sans-serif', 'monospace', 'Times New Roman', 'Arial', 'Helvetica', 'Calibri']
        },
        fontSize: {
          options: [10, 12, 'default', 16, 18, 20, 22],
          supportAllValues: true
        },
        fullscreen: {
          onEnterCallback: container =>
            container.classList.add(
              'editor-container',
              'editor-container_classic-editor',
              'editor-container_include-fullscreen',
              'main-container'
            )
        },
        htmlSupport: {
          allow: [
            {
              name: /^.*$/,
              styles: true,
              attributes: true,
              classes: true
            }
          ]
        },
        image: {
          toolbar: [
            'toggleImageCaption',
            'imageTextAlternative',
            '|',
            'imageStyle:inline',
            'imageStyle:wrapText',
            'imageStyle:breakText',
            '|',
            'resizeImage'
          ]
        },
        link: {
          addTargetToExternalLinks: true,
          decorators: {
            isOpenInNewTab: {
              mode: 'manual',
              label: '在新視窗打開',
              defaultValue: true,
              attributes: {
                target: '_blank',
                rel: 'noopener noreferrer'
              }
            }
          }
        },
        list: {
          properties: {
            styles: true,
            startIndex: true,
            reversed: true
          }
        },
        placeholder: '',
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties']
        }
      },
      ckeditorInsertLibraryFileCommand: null
    }
  },
  watch: {
    data(val) {
      this.init()
    },
    isManager(val) {
      this.form.is_manager = val
    }
  },
  mounted() {
    window.tailwind.svgLoader()

    this.init()
  },
  methods: {
    init() {
      if (this.data != null) {
        this.form = this.data
        this.post_date = this.form.post_date != null ? this.$moment(this.form.post_date).toDate() : null
        this.display_at = this.form.display_at != null ? this.$moment(this.form.display_at).toDate() : null
        this.end_at = this.form.end_at != null ? this.$moment(this.form.end_at).toDate() : null
        this.mode = 'update'
      }
    },
    showFileInsertor(ckeditorCommand) {
      this.ckeditorInsertLibraryFileCommand = ckeditorCommand
      this.$refs.fileInsertor.onShow()
    },
    async onSelectInsertFile(file) {
      if (file.file.format.mime_type.startsWith('image/')) {
        const image = await this.getLibraryItem(this.currentSite.site_id, file.item_code)
        this.ckeditorInsertLibraryFileCommand(true, image.data.public_url)
      } else {
        this.ckeditorInsertLibraryFileCommand(false, `/file/${file.item_code}`, file.item_name)
      }
    },
    getFontName(font) {
      return font.toLowerCase().replace(/\s/g, '-')
    },
    disabledStartDate(date) {
      return this.datepickerDisabledStartDate(date, this.end_at)
    },
    disabledStartTime(date) {
      return this.datepickerDisabledStartTime(date, this.end_at)
    },
    disabledEndDate(date) {
      return this.datepickerDisabledEndtDate(date, this.display_at)
    },
    disabledEndTime(date) {
      return this.datepickerDisabledEndTime(date, this.display_at)
    },
    async onSave() {
      this.loading = true
      this.errors = {}

      this.form.site_id = this.site.site_id
      this.form.content = this.trim(this.form.content, '<p><br></p>')

      this.form.post_date = this.post_date != null ? this.$moment(this.post_date).format() : null
      this.form.display_at = this.display_at != null ? this.$moment(this.display_at).format() : null
      this.form.end_at = this.end_at != null ? this.$moment(this.end_at).format() : null

      let response

      if (this.mode === 'create') {
        response = await this.createSiteEssay(this.site.site_id, this.form)
      } else {
        response = await this.updateSiteEssay(this.site.site_id, this.data.essay_id, this.form)
      }

      if (response.body && 'errors' in response.body) {
        this.errors = response.body.errors
        this.loading = false
      } else {
        let option = {
          title: (this.mode === 'create') ? '已成功新增項目' : '已成功更新項目',
          message: '請稍後，將會轉至' + (this.form.is_manager ? '社服隨筆' : '新中心/新計劃服務巡禮') + '頁面',
          type: 'success'
        }

        if (response.code === 0) {
          this.finish = true

          setTimeout(() => {
            this.$router.push('/social-essays?isManager=' + (this.form.is_manager ? '1' : '0'))
          }, 1000)
        } else {
          this.loading = false
          option = {
            title: (this.mode === 'create') ? '未能新增隨筆' : '未能更新隨筆',
            message: response.data.message ?? '系統錯誤，請稍後再試',
            type: 'error'
          }
        }

        this.$notify(option)
      }
    }
  }
}
</script>

<style scoped lang="scss">
#social-essay-form {
  ::v-deep {
    .ql-editor {
      height: 100%;
      flex: 1;
      overflow-y: auto;
      width: 100%;
    }
  }
}
</style>
